<div *ngIf="!resetPasswordToken">
  <form autocomplete="off" (ngSubmit)="resetPass()">
    <img
      *ngIf="!authFromHelpUkraine && !authWcd"
      src="assets/img/logo.svg"
      [alt]="'GLOBAL.app_name' | translate"
      class="logo logo--centered"
    />
    <img
      *ngIf="authFromHelpUkraine"
      src="assets/img/help-ukraine/PH_logo_UA.webp"
      [alt]="'GLOBAL.app_name' | translate"
      class="logo logo--centered"
    />
    <img
      *ngIf="authWcd"
      src="assets/img/wcd/ldiwXph.svg"
      [alt]="'GLOBAL.app_name' | translate"
      class="logo logo--centered"
    />

    <div class="card__description text--center">
      {{ 'AUTH.reset_password_description' | translate }}
    </div>
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.your_email' | translate"
        type="email"
        [validation]="'email'"
        [correctForm]="form"
        name="email"
      ></app-ph-input>
    </div>
    <div class="form__action">
      <button class="btn btn--primary btn--block btn--lg" [disabled]="btnDisabled">
        {{ 'GLOBAL.send' | translate }}
      </button>
    </div>
  </form>
</div>
<div class="login-form__reset-password" *ngIf="resetPasswordToken">
  <form autocomplete="off" (ngSubmit)="resetPassConfirm()">
    <img
      src="assets/img/logo.svg"
      [alt]="'GLOBAL.app_name' | translate"
      class="logo logo--centered"
    />
    <div class="form__group">
      <div class="card__title card__title--hello text--center">
        {{ 'GLOBAL.hello' | translate
        }}{{ resetPasswordName ? ' ' + resetPasswordName + '!' : '!' }}
      </div>
      <div class="card__description text--center">
        {{ 'GLOBAL.set_your_new_passsword' | translate }}
      </div>
      <app-ph-input
        [placeholder]="'FORMS.new_password' | translate"
        [validation]="'password'"
        [errorDescription]="true"
        [correctForm]="formPassConfirm"
        name="password"
        type="password"
      ></app-ph-input>
    </div>
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.repeat_password' | translate"
        [validation]="'password'"
        [correctForm]="formPassConfirm"
        sameValue="password"
        name="resetPassword"
        type="password"
      ></app-ph-input>
    </div>
    <div class="form__action">
      <button class="btn btn--primary btn--block btn--lg" [disabled]="btnDisabledConfirm">
        {{ 'GLOBAL.set_new_passsword' | translate }}
      </button>
    </div>
  </form>
</div>
<div class="form__link form__link--sign-up">
  <span>{{ 'AUTH.i_have_my_old_password' | translate }}</span>
  <a
    [routerLink]="[]"
    [queryParams]="authPage('login')"
    class="text--primary-light text--decorated"
    >{{ 'AUTH.sign_in' | translate }}</a
  >
</div>
